import clsx from 'clsx';
import React from 'react';
import GreenCheckIcon from '../../assets/icons/check-green-icon.svg?react';

interface CorrectiveActionCreatedProps {
  otherClasses?: string;
}

const CorrectiveActionCreated: React.FC<CorrectiveActionCreatedProps> = ({
  otherClasses,
}) => {
  const correctiveActionCreatedClasses = clsx(
    otherClasses,
    'flex flex-col items-center gap-2.5 text-center',
  );

  return (
    <div
      className={correctiveActionCreatedClasses}
      data-testid="corrective-action-created"
    >
      <GreenCheckIcon className="h-12 w-12 md:h-85 md:w-85" />
      <h4 className="text-brand-papery">Corrective Action Created</h4>
      <p className="font-inter-variable text-brand-papery text-lg leading-5 font-normal">
        An email has been sent to the person(s) to whom the action has been
        assigned.
      </p>
    </div>
  );
};

export default CorrectiveActionCreated;
